module.exports = __webpack_public_path__ + "static/img/73-3.db7bd90.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/73-3.jpg
// module id = 9C0S
// module chunks = 0